/*global GridController*/

var TrackedPostmailEventEmbeddable = function(options){    
    GridController.call(this,"iz_tracked_postmail_event", 
    {
        directory: "views/tracked",
        name: "trackedPostmailEventGrid",
        joinFetch: [
            { otherTable: "ir_attachment", readOnly: true, type: "2one", name: "attach", thisField: "id", otherField: "res_id", joinSearch: {res_model: "iz.tracked.postmail.event"}},
        ]
    }) ;

    /**
     * This is called when the embeddable is loaded with data (typically a view render)
     * 
     * @param {object} data the data given to the embedded instance (for example : the customer)
    */
    this.prepareDataOnEnter = function(data, callback){
        if(data && options && options.searchfield){
            //if we receive some data, we update the grid search options with a new
            //search criteria
            //the this.options object will be filled from HTML markup
            this.searchOptions = {} ;
            this.searchOptions[options.searchfield] = data.id ;
        }
        //call the normal function on the grid super class to continue with standard grid behavior
        GridController.prototype.prepareDataOnEnter.call(this, data, callback) ;
    } ;

    this.onDownload = function(ev){
        var event = ev.data.data ;
        this.view.longTask(function(done){
            this.api.readBinary.download(event.attach, event.attach.datas_fname, function(err){
                if(err){ return done(err) ;}
                done() ;
            }.bind(this)) ;
        }.bind(this)) ;
    } ;
} ;

TrackedPostmailEventEmbeddable.prototype = Object.create(GridController.prototype);
TrackedPostmailEventEmbeddable.prototype.constructor = TrackedPostmailEventEmbeddable;

module.exports = TrackedPostmailEventEmbeddable ;